<template>
  <div class="canvas-container" ref="canvasContainer">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
export default {
  name: "KoioteCanvasLabel",

  props: {
    input: Object,
  },

  data() {
    return {
      label: this.input.customized?.label?.length > 0 ? `${this.input.customized.label}: ` : "???",
    };
  },

  mounted() {
    this.updateCanvasSize();
    this.drawText(); // Dibuja el texto inicialmente

    // Observador para cambios en el tamaño del contenedor
    const resizeObserver = new ResizeObserver(() => {
      this.updateCanvasSize();
    });

    resizeObserver.observe(this.$refs.canvasContainer);

    this.$once('hook:beforeDestroy', () => {
      resizeObserver.disconnect(); // Limpia el observador al destruir el componente
    });
  },

  methods: {
    updateCanvasSize() {
      const container = this.$refs.canvasContainer;
      const canvas = this.$refs.canvas;

      // Ajusta el tamaño del canvas al del contenedor
      canvas.width = container.offsetWidth;
      canvas.height = container.offsetHeight;

      this.drawText(); // Redibuja el texto al cambiar el tamaño
    },

    drawText() {
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");

      // Limpiar el canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Establecer estilos de texto
      ctx.fillStyle = this.input.customized.foreground_color;
      
      // Ajustar el tamaño de fuente para que ocupe todo el alto del canvas
      const fontSize = Math.min(canvas.height, canvas.width / (this.label.length || 1)); // Ajustar según el ancho y alto
      ctx.font = `${fontSize}px Arial`; // Usar un tamaño de fuente basado en el canvas

      // Calcular la posición del texto para centrarlo
      const textWidth = ctx.measureText(this.label).width;
      const x = (canvas.width - textWidth) / 2; // Centrar horizontalmente
      const y = (canvas.height + fontSize / 2) / 2; // Centrar verticalmente

      // Dibujar el texto
      ctx.fillText(this.label, x, y);
    },
  },
};
</script>

<style scoped>
.canvas-container {
  position: relative;
  width: 100%;
  height: 100%;
}
canvas {
  display: block; /* Elimina el espacio en la parte inferior del canvas */
  width: 100%; /* Opcional, para asegurarse de que el canvas ocupe el espacio */
  height: 100%; /* Opcional, para asegurarse de que el canvas ocupe el espacio */
}
</style>
